//Library Imports
import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useCookies } from "react-cookie";
import React from "react";

//Local Imports
import lowerBg from "../../../../assets/img/BG.svg";
import OnBoarding1 from "./OnBoarding1";
import OnBoarding2 from "./OnBoarding2";
import OnBoarding3 from "./OnBoarding3";
import OnBoarding4 from "./OnBoarding4";

//Style Imports
import styled from "styled-components";

const LaunchIntro: React.FC = (props) => {
  const [level, setLevel] = useState(0);
  const [cookies, setCookie, removeCookie] = useCookies([]);

  let history = useHistory();

  useEffect(() => {
    if (level > 2) {
    } else {
      setTimeout(() => {
        setLevel(level + 1);
      }, 4800);
    }
  }, [level]);

  function transitionalRendering() {
    // console.log("level", level);
    switch (level) {
      case 0:
        return <OnBoarding1 />;
      case 1:
        return <OnBoarding2 />;
      case 2:
        return <OnBoarding3 />;
      case 3:
        return <OnBoarding4 />;

      default:
        if (cookies["appName"] !== "workbench") {
          history.push("/content/search"); // redirecting to Smart Content as required in WB 4.0
        } else {
          history.push("content/search");
        }
        break;
    }
  }
  return (
    <>
      <Wrapper>{transitionalRendering()}</Wrapper>
    </>
  );
};

export default React.memo(LaunchIntro);

const Wrapper = styled.div`
  .onBoarding {
    display: flex;
    flex-grow: 2;
    justify-content: center;
    align-items: center;
  }
  .welcome-text {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 2;
    .heading {
      h4 {
        color: rgb(66, 75, 80);
        font-family: roboto_slabregular;
        font-weight: 400;
        font-size: 60px;
        line-height: 60px;
        letter-spacing: -1.5px;
        margin-bottom: 0px;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 42px;
          line-height: 42px;
        }
      }
    }
  }
  .get-started {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    background-image: url(${lowerBg});
    background-repeat: no-repeat;
    background-size: cover;
  }
  .welcome-text {
    .heading {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .welcome-text h4 {
    color: #424b50;
    font-family: "Roboto Slab", serif;
    font-weight: bold;
    font-size: 40px;
    font-weight: 400;
    font-size: 60px;
    line-height: 60px;
    letter-spacing: -1.5px;
    margin-bottom: 0px;
  }
`;
